export default function KpiCard({ label, value, sub, testid, tone = "default" }) {
  const tones = {
    default: "text-slate-900",
    danger: "text-red-700",
    warn: "text-amber-700",
    good: "text-emerald-700",
    info: "text-sky-700",
  };
  return (
    <div data-testid={testid} className="bg-white border border-slate-200 rounded-lg p-5 min-w-0">
      <div className="text-[11px] uppercase tracking-[0.1em] text-slate-500 font-semibold">{label}</div>
      <div className={`mt-3 font-mono text-[26px] font-semibold tracking-tight leading-none ${tones[tone]} truncate`}>
        {value}
      </div>
      {sub ? <div className="mt-2 text-xs text-slate-500 truncate">{sub}</div> : null}
    </div>
  );
}
